import { render, staticRenderFns } from "./TokenPage.vue?vue&type=template&id=b1dcf4ca&"
import script from "./TokenPage.vue?vue&type=script&lang=js&"
export * from "./TokenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports